import { useEffect, useState } from 'react';
import apiService from 'services/BackendApi/BackendApi';

export function useTaxonomyPagination(props) {
	const { category, page, respp, location, tid } = props;
	const [pageContent, setPageContent] = useState({
		isLoading: false,
		isError: false,
		payload: null,
		error: null,
	});
	useEffect(() => {
		setPageContent((prevPageContent) => ({
			...prevPageContent,
			isLoading: true,
		}));
		apiService
			.GetTaxonomyInfo(
				{
					params: {
						category: category,
						location: location,
						page: page,
						respp: respp,
						id: tid,
						orderby: 'desc',
					},
				}
			)
			.then((response) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: false,
					payload: {
						...response.data,
					},
				}));
			})
			.catch((error) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: true,
					error: error?.message,
				}));
			})
			.finally(() => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isLoading: false,
				}));
			});
	},[category,page,location]);

	return pageContent;

}

export function useTaxonomyTitle(props) {
	const {tid} = props;
    const [pageContent, setPageContent] = useState({
        isLoading: false,
        isError: false,
        payload: null,
        error: null,
    });
    useEffect(() => {
		setPageContent((prevPageContent) => ({
			...prevPageContent,
			isLoading: true,
		}));
		apiService
			.GetTaxonomyTitle(
                {
                    urlParams: {
                        tid: tid,
                    }
                }
            )
			.then((response) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: false,
					payload: {
						...response.data,
					},
				}));
			})
			.catch((error) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: true,
					error: error?.message,
				}));
			})
			.finally(() => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isLoading: false,
				}));
			});
	}, [tid]);

	return pageContent;
}
